const objFromArrayFaq = (arr: any[], key: string = 'donated_accounts_id') => arr.reduce((accumulator, current) => {
  accumulator[current[key]] = current;
  return accumulator;
}, {});

export default objFromArrayFaq;
